import { render, staticRenderFns } from "./AiJdDetail.vue?vue&type=template&id=af1bb2f4&scoped=true&"
import script from "./AiJdDetail.vue?vue&type=script&lang=js&"
export * from "./AiJdDetail.vue?vue&type=script&lang=js&"
import style0 from "./AiJdDetail.vue?vue&type=style&index=0&id=af1bb2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1bb2f4",
  null
  
)

export default component.exports